var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h2", { staticClass: "mb-10" }, [
            _vm._v("Orden de Pago con Cargo a Gasto de Representación")
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Tipo de actividad" } },
                  [
                    _c("b-form-radio-group", {
                      attrs: {
                        "data-cy": "type-activity",
                        options: _vm.optionsTypeActivity,
                        name: "typeActivity",
                        stacked: ""
                      },
                      model: {
                        value: _vm.formData.typeActivity,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "typeActivity", $$v)
                        },
                        expression: "formData.typeActivity"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Motivo *" } },
                  [
                    _c("b-form-textarea", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has("custom-document.reason")
                          ? false
                          : null,
                        "data-cy": "reason",
                        "data-vv-as": "motivo",
                        name: "reason",
                        maxLength: "5000",
                        rows: "3",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "reason", $$v)
                        },
                        expression: "formData.reason"
                      }
                    }),
                    _c("div", { staticClass: "row justify-content-between" }, [
                      _c("div", { staticClass: "col-md-6 text-left" }, [
                        _vm.errors.has("custom-document.reason")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "con-text-validation span-text-validation-danger v-enter-to"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "span-text-validation" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "custom-document.reason"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "col-md-6 text-right" }, [
                        _c(
                          "small",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formData.reason.length) +
                                "/5000 "
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c("form", { attrs: { "data-vv-scope": "custom-document-part-2" } }, [
        _c("div", { staticClass: "row mb-3" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-md-12 mt-3" },
            [_c("add-document", { on: { "add-document": _vm.addDocument } })],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12 mt-3" },
            [
              _c("table-documents", {
                attrs: { documents: _vm.formData.documents, multiple: "" },
                model: {
                  value: _vm.formData.documentsSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "documentsSelected", $$v)
                  },
                  expression: "formData.documentsSelected"
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row align-items-center mt-5" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "col-md-3 align-items-end" },
              [
                _c("UploadFile", {
                  attrs: {
                    permission: "*",
                    accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                    text: "Seleccionar documentos",
                    "upload-to": "ed",
                    "button-class": {
                      "btn-block": true,
                      "mb-5": _vm.errors.has("custom-document.fileName")
                    },
                    "container-class": "w-100"
                  },
                  on: {
                    input: function($event) {
                      return _vm.addOthersFile()
                    }
                  },
                  model: {
                    value: _vm.fileOthers,
                    callback: function($$v) {
                      _vm.fileOthers = $$v
                    },
                    expression: "fileOthers"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "row align-items-center mt-1" },
            [
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED060",
                          expression: "'ED060'"
                        },
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "add-file-repository",
                          expression: "'add-file-repository'"
                        }
                      ],
                      staticClass: "btn-icon mt-1",
                      attrs: {
                        variant: "secondary",
                        "data-cy": "from-repository"
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                      _vm._v(" Desde el repositorio ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.attachments, function(file) {
                return _c("div", { key: file.id, staticClass: "col-2" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "45px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(_vm._s(file.name))]
                      ),
                      _c("vs-button", {
                        attrs: { color: "danger", type: "flat", icon: "clear" },
                        on: {
                          click: function($event) {
                            return _vm.removeOthersFile(file.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              }),
              _c("div", { staticClass: "col-md-12" }, [
                !!_vm.error.messageOthers
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-left"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(" " + _vm._s(_vm.error.messageOthers) + " ")
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ])
      ]),
      _vm.error.message !== ""
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger\n          vs-input--text-validation-span v-enter-to text-right",
              staticStyle: { height: "32px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.error.message) + " ")
              ])
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "cancel",
                color: "primary",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "save",
                color: "success",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [
              _vm._v(" Crear "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saving,
                    expression: "saving"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-primary"
              })
            ]
          )
        ],
        1
      ),
      _c("repository-selector", {
        attrs: {
          "modal-id": "add-file-repository",
          "add-file": _vm.addFileRepo,
          files: _vm.formData.attachments,
          "remove-file": _vm.removeOthersFile
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Documentos *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }